(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["playon-announcement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('playon-announcement')) {
  class PlayOnAnnouncement extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced === 'true') return;
      const button = this.querySelector('.pos-announcement-toggle');
      if (!button) return;
      this.dataset.enhanced = 'true';
      button.hidden = false;
      button.addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        const label = paused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
        button.querySelector('span').textContent = label;
        button.setAttribute('aria-label', label);
      });
      button.setAttribute('aria-label', this.dataset.pauseLabel);
    }
  }
  customElements.define('playon-announcement', PlayOnAnnouncement);
}

  } catch(e) { console.error(e); }
})();
})();
